import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Image from 'components/common/Image';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import Button from 'components/common/Button';

const createAssetFilePath = (device, rate, type, name, extname) => {
  const rateName = rate === 1 ? '' : `@${rate}x`;
  return `./images/${device}/@${rate}x/img_facility_${type}_${name}${rateName}.${extname}`;
};

const assetFile = (device, rate, type, name) => {
  const extname = rate === 1 ? 'png' : 'jpg';
  return createAssetFilePath(device, rate, type, name, extname);
};

const assetWebpFile = (device, rate, type, name) =>
  createAssetFilePath(device, rate, type, name, 'webp');

const FacilityInfo = ({
  className,
  brandName,
  name,
  title,
  facilityLink,
  ygetsLink,
  description,
  location,
  valid = false
}) => (
  <div className={`${valid ? 'available' : 'not-available'} ${className}`}>
    <div
      className="link-facility"
      onClick={() => valid && window.open(facilityLink)}
    >
      <div className="facility-img">
        <div className="overlay">
          <Image
            pc1x={assetFile('PC', 1, brandName, name)}
            pc2x={assetFile('PC', 2, brandName, name)}
            sp2x={assetFile('SP', 2, brandName, name)}
            sp3x={assetFile('SP', 3, brandName, name)}
            webpPC1x={assetWebpFile('PC', 1, brandName, name)}
            webpPC2x={assetWebpFile('PC', 2, brandName, name)}
            webpSP2x={assetWebpFile('SP', 2, brandName, name)}
            webpSP3x={assetWebpFile('SP', 3, brandName, name)}
            alt={`img_facility_${brandName}_${name}`}
          />
        </div>
        <p className="preparation">現在準備中</p>
      </div>
      <div className="info">
        <p className="title">{title}</p>
        <p className="info-description">{description}</p>
        <p className="location">{location}</p>
      </div>
    </div>
    <div className="ygets-link">
      <Button buttonType="D" onClick={() => valid && window.open(ygetsLink)}>
        {valid ? 'ギフト券で予約' : 'ギフト券利用対象外'}
      </Button>
    </div>
  </div>
);

const commonStyle = css`
  display: flex;
  flex-direction: column;
  height: 100%;

  .preparation {
    display: none;
  }

  &.not-available {
    .link-facility {
      cursor: not-allowed;
    }

    .facility-img {
      position: relative;

      .overlay {
        background-color: ${Colors.black1};

        img {
          opacity: 0.7;
        }
      }

      .preparation {
        display: block;
        position: absolute;
        margin: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        text-align: center;
        color: ${Colors.white1};
        ${FontStyles.text8};
        opacity: 0.7;
      }
    }

    .title {
      color: ${Colors.gray1};

      &:hover,
      &:active {
        color: ${Colors.gray1};
        cursor: pointer;
      }
    }

    .info-description {
      color: ${Colors.gray1};
    }

    ${Button} {
      color: ${Colors.gray1};
      background-color: ${Colors.gray3};
      border: none;
      box-shadow: none;
      cursor: not-allowed;
    }
  }

  &.available {
    .link-facility {
      cursor: pointer;

      &:active {
        picture {
          opacity: 0.4;
        }
        .title {
          color: ${Colors.orange3};
        }
      }
    }
  }

  .title {
    margin: 0;
    padding: 10px 0;
    color: ${Colors.orange1};
  }

  .info-description {
    ${FontStyles.text8};
    color: ${Colors.black1};
    margin-bottom: 16px;
  }

  .location {
    ${FontStyles.text8};
    color: ${Colors.gray1};
    margin-bottom: 16px;
  }

  ${Button} {
    margin: 0;
    width: 100%;
    cursor: pointer;
  }

  .ygets-link {
    margin-top: auto;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  width: 214px;

  &.available {
    .link-facility {
      &:hover {
        cursor: pointer;
        picture {
          opacity: 0.4;
        }
        .title {
          color: ${Colors.orange3};
        }
      }
    }
  }

  .link-facility {
    margin-bottom: 22px;
  }

  .facility-img {
    img {
      width: 100%;
      min-height: 152px;
    }
  }

  .title {
    ${FontStyles.text6};
    padding-bottom: 6px;
  }

  .info-description {
    margin: 0;
  }

  .location {
    margin: 8px 0 0;
  }

`;

const spStyle = CustomMedia.lessThan('medium')`
  width: 100%;

  .link-facility {
    margin-bottom: 14px;
  }

  .facility-img {
    width: 100%;
    position: relative;

    &:before{
      content:'';
      display:block;
      width:100%;
      height:0;
      padding-bottom: 74.46808510638298%;
    }

    .overlay {
      position:absolute;
      width: 100%;
      top: 0;
      left: 0;
    }

  }

  picture {
    display: inline-block;
    width: 100%;
    text-align: center;

    img {
      width: 100%;
    }
  }

  .info,
  .ygets-link {
    padding: 0 16px;
  }

  .info {
    .title {
      ${FontStyles.text4};
      padding: 10px 0;
    }

    .info-description {
      margin: 0;
    }

    .location {
      margin: 10px 0 0;
    }
  }

  .ygets-link {
    ${Button}{
      height: 40px;
      ${FontStyles.text8};
    }
  }

`;

export default applyStyles(FacilityInfo)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Home/components/FacilityInfo.js